import React from "react";
import "./TasksHeader.css";
import { ChevronLeft, ChevronRight } from "lucide-react";

const TasksHeader = ({
  todos,
  appointments,
  showScroll = true,
  children,
  refObj,
}) => {
  const scrollLeft = () => {
    if (refObj?.current)
      refObj.current.scrollBy({ left: -170, behavior: "smooth" });
  };

  const scrollRight = () => {
    if (refObj?.current)
      refObj.current.scrollBy({ left: 170, behavior: "smooth" });
  };

  return (
    <div className="tasks-header ng_p_2_r" role="tasks-header">
      <div>
        <label>
          {todos !== undefined && `${todos} To-dos`}
          {todos !== undefined && appointments !== undefined && ", "}
          {appointments !== undefined && `${appointments} Appointments`}
        </label>
        {showScroll && (
          <div className="header-buttons" role="header-buttons">
            <button
              onClick={scrollLeft}
              className="scroll-button"
              role="left-button"
            >
              <ChevronLeft size={20} />
            </button>
            <button
              onClick={scrollRight}
              className="scroll-button"
              role="right-button"
            >
              <ChevronRight size={20} />
            </button>
          </div>
        )}
      </div>
      {children}
    </div>
  );
};

export default TasksHeader;
